module.exports = __webpack_public_path__ + "media/img/scholarships/English-a5ffc00772aefe79b8442bae97afc356.png";